import { defineAsyncComponent, App } from 'vue';
const ModalOverlay = defineAsyncComponent(() => import('@/project/modals/ModalOverlay.vue'));
const ResponsiveIconWrap = defineAsyncComponent(() => import('@/project/shared/ResponsiveIconWrap.vue'));
const ProductTile = defineAsyncComponent(() => import('@/project/product/product-tile/ProductTile.vue'));
const ReadMore = defineAsyncComponent(() => import('@/core/ui-components/ReadMore.vue'));

export default function config(app: App): void {
    // Global components that we want to use on multiple pages
    app.component('ResponsiveIconWrap', ResponsiveIconWrap);
    app.component('ModalOverlay', ModalOverlay);

    // Due to recursiveness
    app.component('ProductTile', ProductTile);
    app.component('ReadMore', ReadMore);
}
